import React from 'react';
import { MapMarker } from './MapMarker';
export function MapMarkerCollection({ children, map, onBoundsKnown, onMarkerSelected, }) {
    const markers = [];
    const bounds = new google.maps.LatLngBounds();
    React.Children.forEach(children, (element) => {
        if (element == null) {
            return;
        }
        if (element.type === MapMarker) {
            const marker = React.cloneElement(element, {
                map,
                onSelected: onMarkerSelected,
            });
            markers.push(marker);
            bounds.extend(marker.props.coordinates);
        }
    });
    if (onBoundsKnown) {
        onBoundsKnown(bounds);
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, markers);
}
